import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 融资状态 - 待删
 */
class FinancingState extends UltMeta {
    TO_CONFIRM = new Meta(1, "待确认");
    CONFIRMING = new Meta(2, "确认中");
    CONFIRMED = new Meta(3, "已确认");
}
export const FINANCING_STATE = new FinancingState();

/**
 * 供应链端融资状态
 */
class SupplierFinancingState extends UltMeta {
    CONFIRMING = new Meta(2, "确认中");
    CONFIRMED = new Meta(3, "已确认");
}
export const SUPPLIER_FINANCING_STATE = new SupplierFinancingState();

/**
 * 客户融资状态
 */
class CustomerFinancingState extends UltMeta {
    TO_CONFIRM = new Meta(0, "待确认");
    CONFIRMED = new Meta(1, "已确认");
}
export const CUSTOMER_FINANCING_STATE = new CustomerFinancingState();

/**
 * 银行融资状态
 */
class BankFinancingState extends UltMeta {
    TO_CONFIRM = new Meta(0, "待确认");
    CONFIRMED = new Meta(1, "已确认");
}
export const BANK_FINANCING_STATE = new BankFinancingState();

class FinancingSearchState extends UltMeta {
    TO_CONFIRM = new Meta(1, "待确认");
    CONFIRMING = new Meta(2, "确认中");
    CONFIRMED = new Meta(3, "已确认");
}
export const FINANCING_SEARCH_STATE = new FinancingSearchState();

// 担保方式
class GuaranteeMethod extends UltMeta {
    PROMISE = new Meta(1, "保证");
    PLEDGE = new Meta(2, "质押");
}
export const GUARANTEE_METHOD = new GuaranteeMethod();

// 担保类型
class GuaranteeType extends UltMeta {
    PERSON = new Meta(1, "个人");
    COMPANY = new Meta(2, "企业");
}
export const GUARANTEE_TYPE = new GuaranteeType();

// 是否第三方担保
class IsThirdGuarantor extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}
export const IS_THIRD_GUAANTOR = new IsThirdGuarantor();
